import { requestPrint } from '@/libs/bixolon/bxlcommon'
import { checkPrinterStatus, cutPaper, getPosData, setCharacterset, setPosId } from '@/libs/bixolon/bxlpos'
import { printLine, printTotals, printItems, printSeparator, printMultiple } from '@/libs/bixolon/receipt-printer'
import { formatCurrency, formatCurrencyCustom, getPosNote, getCummulatedDiscount } from '@/libs/bixolon/helpers'
import state from '@/state'
import { df } from '@/plugins/firebase'
import { printerErrors } from '@/libs/jsPrintManager/utils'
import * as JSPM from 'jsprintmanager'

export const printerInit = (issueID) => {
  checkPrinterStatus()
  setCharacterset(1250)
  setPosId(issueID)
}

const viewResult = (result) => {
  if (result === 'Cannot connect to server') {
    alert('Pisač je nedostupan.')
  }
}

export const printVirman = async (printer, data, response) => {
  const printerType = printer?.library

  // Fix za staru konfiguraciju
  if (!['UNIVERSAL', 'NONE'].includes(printerType)) {
    if (!printer.font) printer.font = 0
    if (!printer.size) printer.size = 0
    if (!printer.width) printer.width = '80'
    if (!printer.line_length) printer.line_length = 48
    if (!printer.library) printer.library = 'BIXOLON'
  }

  let pName = printer.printer_name
  let fullVirman
  if (response && response.data && response.data.full_virman) {
    fullVirman = response.data.full_virman
  } else {
    console.error('fullVirman is missing from response.')
    return
  }

  let [escpos, doc, printerConfiguration] = [null, null, null]
  var currency = 'EUR'

  // const taxRecapitulation = calculateTaxRecapitulation(fullVirman, currency)
  const posNote = await getPosNote()

  const company = state.getCurrentCompany()
  const pointOfSale = state.getPointOfSale()
  // const cashRegister = state.getCashRegister()

  const cashRegisterResponse = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
  const cashRegister = cashRegisterResponse.data()
  const currencySymbol = printer.euro_symbol_type ?? '€'

  printerConfiguration = printer

  if (printerType === 'UNIVERSAL') {
    if (!window.Neodynamic || !window.Neodynamic.JSESCPOSBuilder) {
      throw new Error('Neodynamic JSESCPOSBuilder library is not loaded. Please refresh the page.')
    }
    escpos = window.Neodynamic.JSESCPOSBuilder
    doc = new escpos.Document()
  }

  // const conversionRate = 7.53450
  // const conversionRateString = '7.53450'
  const paymentMethod = fullVirman.payment_method

  const companyAddress = `${fullVirman.company_details.address}, ${fullVirman.company_details.zip_code} ${fullVirman.company_details.city}`
  const pointOfSaleAddress = `${fullVirman.location_details.address}, ${fullVirman.location_details.zip_code} ${fullVirman.location_details.city}`
  const separator = company.receipt_numeration_separator // TODO: Vidjeti da li se ovdje radi o rcpt_separator, receipt_numeration_separator ne postoji u company_details

  var virmanSequence = 0
  if (cashRegister && cashRegister.virman_sequence) {
    virmanSequence = cashRegister.virman_sequence
  }

  const receiptId = `${virmanSequence + 1}${separator}${pointOfSale.location_id}${separator}${cashRegister.number}`

  const total = fullVirman.total
  const fullTotal = fullVirman.full_total

  // const discount = data.discount ? data.discount : 0
  const options = {
    horizontal: 0,
    vertical: 0,
    bold: false,
    invert: false,
    underline: false,
    font: printerConfiguration.font,
    alignment: 0,
    printerConfiguration: printerConfiguration,
    document: doc,
    escpos: escpos
  }

  if (state.getPrinterLib === 'UNIVERSAL') {
    options.font = printerConfiguration.font
  } else {
    if (printerConfiguration.font === 'A') options.font = 0
    else if (printerConfiguration.font === 'B') options.font = 1
    else if (printerConfiguration.font === 'C') options.font = 2
  }

  function getOptions (option) {
    const modifiedOptions = JSON.parse(JSON.stringify(options))
    Object.keys(option).forEach(key => {
      modifiedOptions[key] = option[key]
    })
    modifiedOptions.document = options.document
    modifiedOptions.escpos = options.escpos
    modifiedOptions.printerConfiguration = options.printerConfiguration

    return modifiedOptions
  }

  var date = new Date(fullVirman.issue_date_time * 1000)
  printLine(fullVirman.company_details.name, getOptions({ alignment: 1 }))
  printLine(companyAddress + ', ' + fullVirman.company_details.country, getOptions({ alignment: 1 }))
  printLine(fullVirman.location_details.name, getOptions({ alignment: 1 }))
  printLine(pointOfSaleAddress, getOptions({ alignment: 1 }))
  printLine(`OIB: ${fullVirman.company_details.oib}`, getOptions({ alignment: 1 }))

  printSeparator(options)
  const operater = fullVirman.seller_id && fullVirman.seller_id !== '' ? fullVirman.seller_id : fullVirman.seller_name

  printTotals('Izdatnica:', receiptId, options)
  printTotals(`Operater: ${operater}`, 'Blagajna: ' + fullVirman.designation.register_number, options)
  printTotals('Datum: ' + ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear(), 'Vrijeme: ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2), options)

  printSeparator(options)

  const type = fullVirman.type
  if (type.payer_oib) {
    const customerAddress = `${type.payer_address}, ${type.payer_zip_code} ${type.payer_city}`

    printLine('Kupac', options)
    printLine(`${type.payer_name.toUpperCase()}`, options)
    printLine(`${customerAddress.toUpperCase()}`, options)
    printLine(`${type.payer_oib.toUpperCase()}`, options)

    printSeparator(options)
  }

  printTotals('Artikl', 'Količina', options)

  printSeparator(options)

  fullVirman.items.forEach(item => {
    printTotals(
      `${item.name.toUpperCase()}`.substring(0, printerConfiguration.line_length - 15),
      formatCurrency(currency, item.amt / 1000),
      options
    )
  })

  printSeparator(options)
  printLine('Ovo nije fiskalizirani račun', getOptions({ alignment: 1, bold: true, horizontal: 0, vertical: 0 }))
  printSeparator(options)
  printLine(posNote, getOptions({ alignment: 1 }))
  const posNoteLength = posNote.split(/\r\n|\r|\n/).length
  printLine('\n'.repeat(posNote !== '' ? posNoteLength + 3 : 3), options)

  if (printerType === 'UNIVERSAL') {
    doc.feed(1).cut()
    var escposCommands = options.document.generateUInt8Array()

    var cpj = new JSPM.ClientPrintJob()

    let selectedPrinter
    if (printerConfiguration.ip_address) {
      if (printerConfiguration.port) {
        selectedPrinter = new JSPM.NetworkPrinter(printerConfiguration.port, printerConfiguration.ip_address)
      } else {
        selectedPrinter = new JSPM.NetworkPrinter(9100, printerConfiguration.ip_address)
      }
    } else {
      selectedPrinter = new JSPM.InstalledPrinter(printerConfiguration.printer_name)
    }

    cpj.clientPrinter = selectedPrinter
    cpj.binaryPrinterCommands = escposCommands

    try {
      await cpj.sendToClient()
      // Success - do NOT emit clear-receipt-data here, payment.js will do it
    } catch (err) {
      printerErrors('JSPM_not_running')
      // Rethrow to let payment.js handle cleanup
      throw err
    }

    return true
  } else if (printerType === 'BIXOLON') {
    cutPaper()
    const strSubmit = getPosData()

    let printerUrl
    if (printerConfiguration && printerConfiguration.ip_address && printerConfiguration.ip_address !== '') {
      printerUrl = printerConfiguration.ip_address
      pName = printerConfiguration.printer_name
    }

    try {
      requestPrint(pName, strSubmit, viewResult, printerUrl)
    } catch (err) {
      alert('Greška pri printanju virmana, molimo pokušajte ponovno!')
      console.error(err)
      // Rethrow to let payment.js handle cleanup
      throw err
    }

    return true
  }
}
